import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [errorRef] = useState(() => `404-${Date.now().toString(36).toUpperCase()}`);

  return (
    <div className="flex-1 bg-[#0b0d2a] flex items-center justify-center px-4 py-20">
      <div className="max-w-lg w-full text-center">
        <div className="text-8xl font-bold text-purple-500 mb-4 select-none">404</div>

        <h1 className="text-2xl font-semibold text-white mb-3">
          Page Not Found
        </h1>

        <p className="text-gray-400 mb-8 leading-relaxed">
          The page <span className="text-gray-300 font-mono text-sm bg-gray-800 px-2 py-0.5 rounded">{location.pathname}</span> doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
          <Link
            to="/"
            className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-500 transition-colors"
          >
            Go to Home
          </Link>
          <button
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}
            className="px-6 py-3 bg-gray-700 text-white rounded-lg font-medium hover:bg-gray-600 transition-colors"
          >
            Go Back
          </button>
        </div>

        <p className="text-gray-600 text-xs">
          Reference: {errorRef}
        </p>
      </div>
    </div>
  );
}

export default NotFoundPage;
